import AdminOrder from 'components/Admin/Orders/List/AdminOrder';

const AdminOrderPageList = () => {
	return <AdminOrder />;
};

export default AdminOrderPageList;
